module.exports = __webpack_public_path__ + "img/save-floppy-disk.009bc036.svg";